import React from "react";
import { Link } from "../../components/LinkIcon";
import { useTranslation } from "react-i18next";
import "./index.less";
const SsoPageContentMobile = () => {
  const { t } = useTranslation();
  const address = "learn.ssoPage.";
  const resource_list = [
    {
      title: t(address + "box_two.left.title"),
      content: t(address + "box_two.left.content"),
      link_describe: t(address + "box_two.left.link"),
      linkUrl: "/apn",
      type: "inlink",
    },
    {
      title: t(address + "box_two.right_one.title"),
      content: t(address + "box_two.right_one.content"),
      link_describe: t(address + "box_two.right_one.link"),
      linkUrl: "https://console.authing.cn",
    },
    {
      title: t(address + "box_two.right_two.title"),
      content: t(address + "box_two.right_two.content"),
      link_describe: t(address + "box_two.right_two.link"),
      linkUrl: "https://docs.authing.cn/v2/reference/sdk-for-sso.html",
    },
    {
      title: t(address + "box_two.right_three.title"),
      content: t(address + "box_two.right_three.content"),
      link_describe: t(address + "box_two.right_three.link"),
      linkUrl: "https://docs.authing.cn/v2/guides/access-control/",
    },
  ];
  return (
    <div className="ssoPage_container_mobile">
      <div className="ssoPage_mobile_box_one">
        <div className="title">{t(address + "box_one.title")}</div>
        <div className="content">
          {t(address + "box_one.content_one")}
          <br /> <br />
          {t(address + "box_one.content_two")}
        </div>

        <img
          src={t("learn.ssoPage.box_one.img")}
          alt="支持多种协议的单点登录"
        />
        <div className="title">{t(address + "box_two.title")}</div>
        <div className="content">{t(address + "box_two.content")}</div>
        {resource_list &&
          resource_list.map((item, index) => (
            <div className="card" key={index}>
              <div className="card_title">{item?.title}</div>
              <div className="card_content">{item?.content}</div>
              <Link
                href={item.linkUrl}
                target={item.type && item.type === "inlink" ? "" : "_blank"}
              >
                {item?.link_describe}
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
};

export { SsoPageContentMobile };
